import queryString from 'query-string';
import { Route, Location } from 'react-router-dom';

import { getUserClassPath } from 'approot/classes/classes.apollo';
import { PRIVATE_ACCOUNT_PROMO_CODE_QUERY_STRING } from 'global/private-routes.constants';
import { RouteConfig } from 'lib/router/router.constants';

export function getLocationParams(location: Location) {
  return queryString.parse(location.search);
}

export function pathWithParentId(
  path: string,
  parentId: string | number | undefined
) {
  return `${getUserClassPath(path)}${parentId ? `?parentId=${parentId}` : ''}`;
}

export function getPromoCodeQueryString(code?: string) {
  return code ? `${PRIVATE_ACCOUNT_PROMO_CODE_QUERY_STRING}${code}` : '';
}

export function pathWithUnknownQueryParams(
  path: string,
  params: URLSearchParams
) {
  const paramsString = params.toString();
  return `${getUserClassPath(path)}${paramsString ? `?${paramsString}` : ''}`;
}

export function pathWithQueryParams(
  path: string,
  params: Record<string, string | number | undefined>
) {
  const queryString = Object.entries(params)
    .filter(([_, value]) => value !== undefined)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

  return `${path}${queryString ? `?${queryString}` : ''}`;
}

export const renderMultipleRoutes = ({
  path,
  component: Element,
  childRoutes,
}: RouteConfig) => {
  const renderRoute = (p: string) => (
    <Route key={p} path={p} element={<Element />}>
      {childRoutes && childRoutes.map(child => renderMultipleRoutes(child))}
    </Route>
  );

  return Array.isArray(path) ? path.map(renderRoute) : renderRoute(path);
};
